const PATTERNS: any = {
    CITY: {
        pattern: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF.\s]+$/,
        message: "Invalid Format. City can only include letters, spaces, and the special character: .",
        maxLength: 20,
    },
    STATE: { pattern: /^[a-zA-Z.\s]+$/, message: "Invalid Format. State can only include letters" },
    EMAIL: {
        pattern: /^[0-9a-zA-Z\u00C0-\u024F\u1E00-\u1EFF_]+([\[\-+.'#+_\]]+[0-9a-zA-Z\u00C0-\u024F\u1E00-\u1EFF-]*)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
        message: "manageAccount.myAccount.familyProtection.validationMsgs.email.pattern",
        maxLength: 100,
    },
    FIRSTNAME: {
        pattern: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s\-']+$/,
        message: "Invalid format. First name can only include letters, spaces, and the special characters: - '",
    },
    MIDDLE_INITIAL: { pattern: /^$|^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]{1}$/, message: "Invalid format. Middle Initial must be one letter.", maxLength: 1 },
    LASTNAME: {
        pattern: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s\-']+$/,
        message: "Invalid format. Last name can only include letters, spaces, and the special characters: - '",
    },
    FIRSTNAME_ADD_CHILD: {
        pattern: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]+(?:[\s-'][a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s]{0,2}[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]+)*$/,
        message: "manageAccount.myAccount.familyProtection.validationMsgs.firstname.pattern",
    },
    LASTNAME_ADD_CHILD: {
        pattern:/^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]+(?:[\s-'][a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s]{0,2}[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]+)*$/,
        message: "manageAccount.myAccount.familyProtection.validationMsgs.lastname.pattern",
    },
    LICENCENUMBER: {
        pattern: /^[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF\*]+$/,
        message: "Invalid format. License Number can only include letters, numbers, and the special character: *",
        maxLength: 30,
    },
    MEDICALINSURANCE: { maxLength: 30 },
    MIDDLENAME: { pattern: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s\-']+$/ },
    PASSWORD: "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{7,}$",
    PHONE: {
        pattern: /^$|^[(]?\d{3}[)]?[-.\s]?\d{3}[-.\s]?\d{4}$/,
        message: "Invalid format. Please enter a 10-digit phone number, in the following format: (888) 123-4567.",
    },
    STREETADDRESS: {
        pattern: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\0-9-#/.\s]+$/,
        message: "Invalid format. Street can only include letters, numbers, and the special characters: #-/.",
        maxLength: 100,
    },
    ZIPCODE: {
        pattern: /(^(?!0{5})(\d{5})(?!-?0{4})(|-\d{4})?$)/,
        message: "Invalid format. Zip Code must be entered in either of the two formats: 01234 OR 01234-5678s",
    },
    IDF_BILLING_PROFILE_ZIPCODE: {
        pattern: /^\d{5}$/,
        message: "Invalid format. Zip Code can only include numbers and must be 5 digits in length (example: 01234)",
    },
    PHONENUMBER: { pattern: /^[^a-zA-Z]*$/ },
    POSTALCODE: { pattern: /^[0-9a-zA-Z]+(?:\s[0-9a-zA-Z]+)*$/ },
    SIN: { pattern: /^[0-9]*$/ },
    DUNSNUMBER: { pattern: /^[0-9]{9}$/ },
    TUOTP: { pattern: /^[0-9]{5}$/ },
    NID: { pattern: /^[a-zA-Z0-9]+$/ },
    COMPANYDOMAIN: { pattern: /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/ },
    REGION: { pattern: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s]*$/ },
    BUSINESSNAME: {
        pattern: /^[a-zA-Z0-9-',.&()\s]+$/,
        message: "Invalid Format. Business Name can only include letters, numbers, spaces, and the special characters: ' . , -()&. ",
        maxLength: 60,
    },
    WEBSITE: { pattern: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9]+(-?[a-zA-Z0-9])*\.)+[\w]{2,}(\/\S*)?$/ },
    EIN: {
        pattern: /^[0-9]{9}$|^([0-9]{2}[-][0-9]{7})$/,
        message: "Invalid format. Employer Identification Number must be a 9 digits number (example: 012345678 or 01-2345678)",
        maxLength: 10,
    },
    BUSINESSSTATEREGISTRYNUMBER: {
        pattern: /^[a-zA-Z0-9]{1,16}$/,
        message: "Invalid format. State Registry Number can be up to 16 characters long and can only include numbers and letters.",
        maxLength: 16,
    },
    URL: { pattern: /(((https|http?:\/\/)|(www\.))[^\s]+)/g },
    USERNAME_OR_EMAIL: {
        pattern: /^((^[A-Za-z0-9.|\\-]+)|(^\w+([-+.'#\w+])*@\w+([-.]\w+)*\.\w+([-.]\w+)*$))$/,
        message: "Please enter valid email address (example:  johndoe@domain.com) or username (example: abc-def)",
        maxLength: 100,
    },
    CARDHOLDERNAME: {
        pattern: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s\-'.]+$/,
        message: "Invalid Format. Cardholder Name can only include letters, spaces, and the special characters: -'.",
        maxLength: 30,
    },
    CARDHOLDERNAMEBILLINGINFOIDFUSER: {
        pattern: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s\-'.]+ [a-zA-Z]+$/,
        message: "Invalid Format. Cardholder Name can only include letters, spaces, and the special characters: -'. Ex FirstName LatsName",
        maxLength: 30,
    },
    DATE: { invalidDateMessage: "Please enter valid date.", futureDateMessage: "Please enter valid date. The given date is a future date. " },
};

export { PATTERNS };
